/* eslint-disable react/no-unescaped-entities */
import React from 'react';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';

const mock = [
  {
    
    description:
      'Class 3 Field trip',
    href : '/class-3-field-trip'
 
  },
  {

    description:
      'Class 4 Field trip',
    href : '/class-4-field-trip'
 
  },
  {
    
    description:
      'Class 5 Field trip',
    href : '/class-5-field-trip'
 
  },
  {
    
    description:
      'Class 6 Field trip',
    href : '/class-6-field-trip'
 
  },
  {
    
    description:
      'Class 7 Field trip',
    href : '/class-7-field-trip'
 
  },
  {
    
    description:
      'Class 8 Field trip',
    href : '/class-8-field-trip'
 
  },
  {
    
    description:
      'Class 8 Visit to Indian Institute of Science ',
    href : '/open-day-event'
 
  },
  {
    
    description:
      'Class 9 Field trip',
    href : '/class-9-field-trip'
 
  },
  {
    
    description:
      'Class 10 Field trip',
    href : '/class-10-field-trip'
 
  },
  {
    
    description:
      'Class 11 Field trip',
    href : '/class-11-field-trip'
 
  },
  {
    
    description:
      'Class 11 Visit to IIsc ',
    href : '/aero-modelling2023'
 
  },
  {
    
    description:
      'Class 12 Field trip',
    href : '/class-12-field-trip'
 
  },
  {
    
    description:
      'National Science day',
    href : '/national-science-day-2023'
 
  },
  

];

const Sidebar_2023 = () => {
  
  return (
    <Box component={Card} variant={'outlined'} padding={2}>
      <Typography
        variant="h6"
        data-aos={'fade-up'}
        sx={{
          fontWeight: 700,
          marginBottom: 2,
        }}
      >
        Extracurricular Activities 2023-24
      </Typography>
      <Grid container spacing={2}>
        {mock.map((item, i) => (
          <Grid key={i} item xs={12}>
            <Box
              component={Card}
              width={1}
              height={1}
              boxShadow={0}
              borderRadius={0}
              display={'flex'}
              flexDirection={{ xs: 'column', md: 'row' }}
              sx={{ backgroundImage: 'none', bgcolor: 'transparent' }}
            >
              <Button href = {item.href}>
                <Typography component={'P'}>
                  {item.description}
                </Typography>
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Sidebar_2023;
